import React from 'react'
import EventBusyIcon from 'components/material-symbol/icons/EventBusy'
import PersonAddIcon from 'components/material-symbol/icons/PersonAdd'
import AccessTimeIcon from 'components/material-symbol/icons/AccessTime'
import TrendingDownIcon from 'components/material-symbol/icons/TrendingDown'
import SendIcon from 'components/material-symbol/icons/Send'

export const RULE_ICONS = {
  CANCELED: <EventBusyIcon />,
  NEW: <PersonAddIcon />,
  DUE: <AccessTimeIcon />,
  LAPSED: <TrendingDownIcon />,
}

export const MANUAL_ICON = <SendIcon />
